/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowAdminModel } from './ShowAdminModel';
import {
    ShowAdminModelFromJSON,
    ShowAdminModelFromJSONTyped,
    ShowAdminModelToJSON,
} from './ShowAdminModel';

/**
 *
 * @export
 * @interface ListShowAdminResponse
 */
export interface ListShowAdminResponse {
    /**
     *
     * @type {number}
     * @memberof ListShowAdminResponse
     */
    limit: number;
    /**
     *
     * @type {number}
     * @memberof ListShowAdminResponse
     */
    offset: number;
    /**
     *
     * @type {number}
     * @memberof ListShowAdminResponse
     */
    total: number;
    /**
     *
     * @type {Array<ShowAdminModel>}
     * @memberof ListShowAdminResponse
     */
    shows: Array<ShowAdminModel>;
}

/**
 * Check if a given object implements the ListShowAdminResponse interface.
 */
export function instanceOfListShowAdminResponse(value: object): boolean {
    if (!('limit' in value)) return false;
    if (!('offset' in value)) return false;
    if (!('total' in value)) return false;
    if (!('shows' in value)) return false;
    return true;
}

export function ListShowAdminResponseFromJSON(json: any): ListShowAdminResponse {
    return ListShowAdminResponseFromJSONTyped(json, false);
}

export function ListShowAdminResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ListShowAdminResponse {
    if (json == null) {
        return json;
    }
    return {
        limit: json['limit'],
        offset: json['offset'],
        total: json['total'],
        shows: (json['shows'] as Array<any>).map(ShowAdminModelFromJSON),
    };
}

export function ListShowAdminResponseToJSON(value?: ListShowAdminResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        limit: value['limit'],
        offset: value['offset'],
        total: value['total'],
        shows: (value['shows'] as Array<any>).map(ShowAdminModelToJSON),
    };
}
